import React from 'react'
import styled from '../../utils/styled'

type BoxProps = {
  flex?: boolean
  inline?: boolean
  fullWidth?: boolean
  flexDirection?: 'row' | 'column'
  justifyContent?: string
  alignItems?: string
  spaceBetween?: boolean
  centerVertical?: boolean
  centerHorizontal?: boolean
  padding?: string
  margin?: string
}

export const Box: React.FC<BoxProps> = ({
  flex = false,
  inline = false,
  fullWidth = false,
  flexDirection = 'row',
  justifyContent,
  alignItems,
  spaceBetween = false,
  centerVertical = false,
  centerHorizontal = false,
  margin,
  padding,
  children
}) => {
  return (
    <StyledBox
      flex={flex}
      inline={inline}
      fullWidth={fullWidth}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      alignItems={alignItems}
      spaceBetween={spaceBetween}
      centerVertical={centerVertical}
      centerHorizontal={centerHorizontal}
      padding={padding}
      margin={margin}
    >
      {children}
    </StyledBox>
  )
}

const StyledBox = styled('div')<BoxProps>`
  display: ${props => {
    if (props.flex) return 'flex'
    if (props.inline) return 'inline'
    return 'block'
  }};
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
  ${({ inline }) => inline && 'width: min-content;'}
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => {
    if (props.justifyContent) return props.justifyContent
    if (props.spaceBetween) return 'space-between'
    if (props.centerHorizontal) return 'center'
    return 'initial'
  }};
  align-items: ${props => {
    if (props.alignItems) return props.alignItems
    if (props.centerVertical) return 'center'
    return 'initial'
  }};
  padding: ${props => props.padding || '0'};
  margin: ${props => props.margin || '0'};
`
